// Support inbox (staff side): the ticket list, its filters and the conversation with the user.
// A ticket is "so'rov" in Uzbek, as on the student platform's help centre.
const support = {
  en: {
    title: 'Support',
    subtitle: 'Answer user requests and get them resolved',
    statsOpen: 'Open',
    statsInProgress: 'In progress',
    statsWaiting: 'Waiting for user',
    statsResolved: 'Resolved today',
    statsUnassigned: 'Unassigned',
    tabAll: 'All',
    tabOpen: 'Open',
    tabInProgress: 'In progress',
    tabWaiting: 'Waiting for user',
    tabResolved: 'Resolved',
    tabClosed: 'Closed',
    searchPlaceholder: 'Search requests...',
    filters: 'Filters',
    filtersTitle: 'Filter requests',
    filtersClear: 'Clear filters',
    filtersDone: 'Done',
    filterCategory: 'Category',
    filterPriority: 'Priority',
    filterAssignee: 'Assignee',
    filterAll: 'All',
    filterUnassigned: 'Unassigned',
    noTickets: 'No requests found',
    noTicketsDesc: 'Try another filter or search.',
    emptyTitle: 'No requests yet',
    emptyDesc: 'When a user asks for help, the request appears here.',
    selectTicket: 'Select a request',
    selectTicketDesc: 'Choose a request from the list to see its conversation and details.',
    loadError: 'Could not load requests',
    retry: 'Retry',
    unread: '{count} unread',
    statusLabel: 'Status',
    priorityLabel: 'Priority',
    assigneeLabel: 'Assignee',
    resolveBtn: 'Resolve',
    closeBtn: 'Close request',
    backBtn: 'Back',
    replyPlaceholder: 'Write a reply...',
    sendBtn: 'Send',
    internalToggle: 'Internal note',
    internalHint: 'Only your team sees it',
    internalTag: 'Internal',
    sendHint: '{keys} to send',
    detailsToggle: 'Details',
    openProfile: "Open the student's profile",
    noMessages: 'No messages yet',
    systemMsg: 'System',
    systemStatusChanged: 'Status changed to {status}',
    statusOpen: 'Open',
    statusInProgress: 'In progress',
    statusWaiting: 'Waiting for user',
    statusResolved: 'Resolved',
    statusClosed: 'Closed',
    catCourses: 'Courses',
    catPayment: 'Payment',
    catTechnical: 'Technical',
    catAccount: 'Account',
    catOther: 'Other',
    priLow: 'Low',
    priNormal: 'Normal',
    priHigh: 'High',
    priUrgent: 'Urgent',
    unassigned: 'Unassigned',
    threadLoadError: 'Could not load the conversation',
    sendError: 'Could not send the message',
    updateError: 'Could not update the request',
    statsLoadError: 'Could not load the statistics',
  },
  ru: {
    title: 'Поддержка',
    subtitle: 'Отвечайте на обращения пользователей и доводите их до решения',
    statsOpen: 'Открытые',
    statsInProgress: 'В работе',
    statsWaiting: 'Ждут ответа',
    statsResolved: 'Решено сегодня',
    statsUnassigned: 'Без исполнителя',
    tabAll: 'Все',
    tabOpen: 'Открытые',
    tabInProgress: 'В работе',
    tabWaiting: 'Ждут ответа',
    tabResolved: 'Решённые',
    tabClosed: 'Закрытые',
    searchPlaceholder: 'Поиск обращений...',
    filters: 'Фильтры',
    filtersTitle: 'Фильтры обращений',
    filtersClear: 'Сбросить фильтры',
    filtersDone: 'Готово',
    filterCategory: 'Категория',
    filterPriority: 'Приоритет',
    filterAssignee: 'Исполнитель',
    filterAll: 'Все',
    filterUnassigned: 'Без исполнителя',
    noTickets: 'Обращений не найдено',
    noTicketsDesc: 'Попробуйте другой фильтр или запрос.',
    emptyTitle: 'Пока нет обращений',
    emptyDesc: 'Когда пользователь обратится за помощью, обращение появится здесь.',
    selectTicket: 'Выберите обращение',
    selectTicketDesc: 'Выберите обращение из списка, чтобы открыть переписку и детали.',
    loadError: 'Не удалось загрузить обращения',
    retry: 'Повторить',
    unread: '{count} непрочитанных',
    statusLabel: 'Статус',
    priorityLabel: 'Приоритет',
    assigneeLabel: 'Исполнитель',
    resolveBtn: 'Решить',
    closeBtn: 'Закрыть обращение',
    backBtn: 'Назад',
    replyPlaceholder: 'Напишите ответ...',
    sendBtn: 'Отправить',
    internalToggle: 'Внутренняя заметка',
    internalHint: 'Видно только вашей команде',
    internalTag: 'Внутренняя',
    sendHint: '{keys} — отправить',
    detailsToggle: 'Детали',
    openProfile: 'Открыть профиль студента',
    noMessages: 'Сообщений пока нет',
    systemMsg: 'Система',
    systemStatusChanged: 'Статус изменён: {status}',
    statusOpen: 'Открыт',
    statusInProgress: 'В работе',
    statusWaiting: 'Ждёт ответа',
    statusResolved: 'Решён',
    statusClosed: 'Закрыт',
    catCourses: 'Курсы',
    catPayment: 'Оплата',
    catTechnical: 'Техническое',
    catAccount: 'Аккаунт',
    catOther: 'Другое',
    priLow: 'Низкий',
    priNormal: 'Обычный',
    priHigh: 'Высокий',
    priUrgent: 'Срочный',
    unassigned: 'Без исполнителя',
    threadLoadError: 'Не удалось загрузить переписку',
    sendError: 'Не удалось отправить сообщение',
    updateError: 'Не удалось обновить обращение',
    statsLoadError: 'Не удалось загрузить статистику',
  },
  uz: {
    title: "Qo'llab-quvvatlash",
    subtitle: "Foydalanuvchilar so'rovlariga javob bering va ularni hal qiling",
    statsOpen: 'Ochiq',
    statsInProgress: 'Jarayonda',
    statsWaiting: 'Javob kutilmoqda',
    statsResolved: 'Bugun hal qilindi',
    statsUnassigned: 'Tayinlanmagan',
    tabAll: 'Barchasi',
    tabOpen: 'Ochiq',
    tabInProgress: 'Jarayonda',
    tabWaiting: 'Javob kutilmoqda',
    tabResolved: 'Hal qilindi',
    tabClosed: 'Yopildi',
    searchPlaceholder: "So'rov qidirish...",
    filters: 'Filtrlar',
    filtersTitle: "So'rovlarni filtrlash",
    filtersClear: 'Filtrlarni tozalash',
    filtersDone: 'Tayyor',
    filterCategory: 'Kategoriya',
    filterPriority: 'Muhimlik',
    filterAssignee: 'Ijrochi',
    filterAll: 'Barchasi',
    filterUnassigned: 'Tayinlanmagan',
    noTickets: "So'rovlar topilmadi",
    noTicketsDesc: "Boshqa filtr yoki qidiruv so'zini sinab ko'ring.",
    emptyTitle: "Hozircha so'rovlar yo'q",
    emptyDesc: "Foydalanuvchi yordam so'rasa, uning so'rovi shu yerda paydo bo'ladi.",
    selectTicket: "So'rovni tanlang",
    selectTicketDesc: "Yozishma va tafsilotlarni ko'rish uchun ro'yxatdan so'rovni tanlang.",
    loadError: "So'rovlarni yuklab bo'lmadi",
    retry: 'Qaytadan',
    unread: "{count} ta o'qilmagan",
    statusLabel: 'Holat',
    priorityLabel: 'Muhimlik',
    assigneeLabel: 'Ijrochi',
    resolveBtn: 'Hal qilish',
    closeBtn: "So'rovni yopish",
    backBtn: 'Orqaga',
    replyPlaceholder: 'Javob yozing...',
    sendBtn: 'Yuborish',
    internalToggle: 'Ichki eslatma',
    internalHint: "Foydalanuvchiga ko'rinmaydi",
    internalTag: 'Ichki',
    sendHint: '{keys} — yuborish',
    detailsToggle: 'Tafsilotlar',
    openProfile: "O'quvchi profilini ochish",
    noMessages: "Hozircha xabarlar yo'q",
    systemMsg: 'Tizim',
    systemStatusChanged: "Holat o'zgardi: {status}",
    statusOpen: 'Ochiq',
    statusInProgress: 'Jarayonda',
    statusWaiting: 'Javob kutilmoqda',
    statusResolved: 'Hal qilindi',
    statusClosed: 'Yopildi',
    catCourses: 'Kurslar',
    catPayment: "To'lov",
    catTechnical: 'Texnik',
    catAccount: 'Hisob',
    catOther: 'Boshqa',
    priLow: 'Past',
    priNormal: 'Oddiy',
    priHigh: 'Yuqori',
    priUrgent: 'Shoshilinch',
    unassigned: 'Tayinlanmagan',
    threadLoadError: "Yozishmani yuklab bo'lmadi",
    sendError: "Xabarni yuborib bo'lmadi",
    updateError: "So'rovni yangilab bo'lmadi",
    statsLoadError: "Statistikani yuklab bo'lmadi",
  },
};

export default support;
